import React, { useState, useEffect } from "react";
import { Row, Col, Card, Form, Input, Button, Modal, message, Select, Empty } from "antd";
import { MinusOutlined, PlusOutlined, CaretDownOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import { useHistory } from "react-router-dom";
import { serverUrl, CWCoreServicesUrl } from "../../constants/config";
import { v4 as uuidv4 } from "uuid";
import Axios from "axios";
import _ from "lodash";
import { clock } from "../../utility/clock";
// import logoIcon from "../../assets/images/cwpos-blue.png";
import MenuIcon from "../../assets/images/menu.png";
import POSLogo from "../../assets/images/cwPosLogo.png";
import DefaultProductImage from "../../assets/images/default-product.webp";
import "../style.css";
import db from "../../database";
import data from "../../constants/purchaseGrn.json";
import BarCodeComponent from "../../lib/BarCodeComponet";

const { Option } = Select;

const STReceipt = () => {
  const dynamicHeight = 0.5625;
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tokens = JSON.parse(localStorage.getItem("tokens"));
  const history = useHistory();

  // CLOCK BLOCK START
  const [displayClock, setDisplayClock] = useState(clock());
  useEffect(() => {
    const timerId = setInterval(() => setDisplayClock(clock()), 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);
  // CLOCK BLOCK END

  const handlePosLogo = () => {
    history.push("/dashboard");
  };

  const setDefaultImage = (e) => {
    e.target.src = DefaultProductImage;
  };

  const [filteredData, setFilteredData] = useState({wastageType: "", skuInput: ""})

  const [wastageTypeProductList, setWastageTypeProductList] = useState([]);

  const onSelect = (value) => {
    setFilteredData({...filteredData, wastageType: value});
    const stIssueDocProductsInput = {
      query: `query{ getInventoryProduct(bUnit:"${tillData.tillAccess.csBunit.csBunitId}", warehouseId:"${tillData.tillAccess.csBunit.mWarehouse.mWarehouseID}"){
        mProductId
	    value
	    name 
        upc
	    csUomId
        uomName 
        }
        }`,
    };
    Axios({
      url: serverUrl,
      method: "POST",
      data: stIssueDocProductsInput,
      headers: {
        "Content-Type": "Application/json",
        Authorization: `${tokens.token_type} ${tokens.access_token}`,
      },
    }).then((response) => {
        let newWastageProduct = [];
        let { getInventoryProduct } = response.data.data;
        let prodCode = _.map([...getInventoryProduct] || [], "value");
        db.products
          .where("value")
          .startsWithAnyOfIgnoreCase(`${prodCode}`)
          .toArray()
          .then((productsFetched) => {
            if (productsFetched?.length > 0) {
                newWastageProduct = [...getInventoryProduct].map((itemLine) => {
                let itemImageIndex = _.findIndex(productsFetched, (item) => item.value === itemLine.productCode);
                return itemImageIndex >= 0
                  ? {
                      ...itemLine,
                      img: productsFetched[itemImageIndex]?.imageurl,
                      qty: 0,
                    }
                  : { ...itemLine, qty: 0 };
              });
            } else {
                newWastageProduct = [...getInventoryProduct].map((prodItem) => ({
                ...prodItem,
                qty: 0,
              }));
            }
            setWastageTypeProductList([...newWastageProduct]);
          });
      });
  };

  const onFieldButton = (fieldIndex, action) => {
    let newWastageProductList = [...wastageTypeProductList];
    if (action === "plus") {
      wastageTypeProductList[fieldIndex].qty += 1;
    } else if (action === "minus" && wastageTypeProductList[fieldIndex].qty > 0) {
      wastageTypeProductList[fieldIndex].qty -= 1;
    } else if (action !== "plus" && action !== "minus") {
      wastageTypeProductList[fieldIndex].qty = Number(action);
    } 
    setWastageTypeProductList([...newWastageProductList]);
  };

  const handleSku = (event) => {
    const code = event.keyCode || event.which;
    if (code === 13) {
      const skuVal = event.target.value;
      const index = wastageTypeProductList.findIndex((element) => {
        return element.value === skuVal || element.name === skuVal;
      });
      if (index !== -1) {
        wastageTypeProductList[index].qty += 1;
        setWastageTypeProductList([...wastageTypeProductList]);
      } else {
        message.error("Product not found");
      }
    }
  };

  const handleReceive = () => {
    const formatYmd = (date) => date.toISOString().slice(0, 10);
    const newDate = formatYmd(new Date());
    const uniqueId = uuidv4()
      .replace(/-/g, '')
      .toUpperCase()
    const wastageProductsArray = [];
    wastageTypeProductList.map((item, index) => {
      item.qty > 0 && wastageProductsArray.push(
        `{
          mProductId : "${item.mProductId}"
          csUomId : "${item.csUomId}"
            qty : ${item.qty}
          }`
      );
    });

    const createGRNInput = {
      query: `mutation {
        insertStockWriteOff (wastage : {
          mWastageId :"${uniqueId}"
          csBunitId : "${tillData.tillAccess.csBunit.csBunitId}"
          mWarehouseId: "${tillData.tillAccess.csBunit.mWarehouse.mWarehouseID}"
          createdby : "${tillData.tillAccess.csUserId}"
          type : "${filteredData.wastageType}"
          date : "${newDate}"
          description : ""
          lines : [${wastageProductsArray}]
        }) {
          code
          status
          message
          documentNo
          recordId
        }
      }`,
    };
    Axios({
      url: serverUrl,
      method: "POST",
      data: createGRNInput,
      headers: {
        "Content-Type": "Application/json",
        Authorization: `${tokens.token_type} ${tokens.access_token}`,
      },
    }).then((response) => {
      if (response.data.data.insertStockWriteOff.code === '200') {
        message.success(response.data.data.insertStockWriteOff.message);
        setFilteredData([]);
        setWastageTypeProductList([]);
      }
    });
  };

  return (
    <div>
      <BarCodeComponent onScan={handleSku} />
      <div style={data.purchaseGrn.header}>
        <Row style={{ height: `${3.7 * dynamicHeight}vw` }}>
          <Col span={2}>
            <img src={MenuIcon} style={data.purchaseGrn.header.menuIcon} alt="" />
          </Col>
          <Col span={10}>
            <label style={data.purchaseGrn.header.posHeadLabel}>{tillData.tillAccess.csBunit.name}</label>
          </Col>
          <Col span={8}>
            <label style={data.purchaseGrn.header.tillName}>{tillData.tillAccess.cwrTill.till}</label>
          </Col>
          <Col span={2} style={data.purchaseGrn.header.right}>
            <label style={data.purchaseGrn.header.time}>{displayClock}</label>
          </Col>
          <Col span={2} style={data.purchaseGrn.header.right}>
            <img onClick={handlePosLogo} src={POSLogo} style={data.purchaseGrn.header.logoIcon} alt="" />
          </Col>
        </Row>
      </div>
      <div style={{ padding: 10 }}>
        <p style={data.purchaseGrn.purchaseText}>Wastage</p>
        <Row style={{ paddingBottom: 10 }}>
          <Col span={12}>
            <Row>
              <Col span={12}>
                <Row>
                  <Col span={8} style={{ alignSelf: "center" }}>
                    <p style={data.purchaseGrn.inputLabel}>Wastage Type</p>
                  </Col>
                  <Col span={16}>
                    <Select
                      // suffixIcon={<CaretDownOutlined />}
                      placeholder="Wastage Type"
                      onChange={(e) => onSelect(e)}
                      value={filteredData.wastageType}
                      style={data.purchaseGrn.supplierSelect}
                      showSearch
                      // allowClear
                      optionFilterProp="children"
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      className="supplierSelect"
                    >
                      <Option key="1" value="DM">
                            DM - Damage
                          </Option>
                          <Option key="2" value="EX">
                            EX - Expired
                          </Option>
                          <Option key="2" value="SC">
                            SC - Scrap
                          </Option>
                    </Select>
                  </Col>
                </Row>
              </Col>
              <Col span={12} style={{ paddingLeft: 10 }}>
                <Row>
                  <Col span={7} style={{ alignSelf: "center" }}>
                    <p style={data.purchaseGrn.inputLabel}>SKU/Name</p>
                  </Col>
                  <Col span={17}>
                    <Input
                      style={data.purchaseGrn.skuInput}
                      className="skuInput"
                      placeholder="SKU/Name"
                      allowClear
                      value={filteredData.skuInput}
                      onChange={(e) => setFilteredData({...filteredData, skuInput: e.target.value})}
                      onKeyPress={handleSku}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={12} />
        </Row>
        <Card key="z" style={data.purchaseGrn.mainCardFirst} bodyStyle={{ padding: 0 }}>
          <Row style={data.purchaseGrn.headingRow}>
            <Col span={12}>
              <strong>Product</strong>
            </Col>
            <Col span={6} style={{textAlign: "center"}}>
              <strong>Wastage Qty</strong>
            </Col>
            <Col span={6} />
          </Row>
          {wastageTypeProductList.length > 0 ? (
            <div>
              <Scrollbars autoHide className="purchaseGrnScroll">
                {wastageTypeProductList.map((item, index) => (
                  <Row style={{ padding: "10px 10px 0px" }}>
                    <Col span={12}>
                      <Row>
                        <Col span={3}>
                          <img onError={setDefaultImage} src={item.img} alt="" style={data.purchaseGrn.prodImgInTable} />
                        </Col>
                        <Col span={19} style={{ paddingTop: 5 }}>
                          <Row>
                            <p style={data.purchaseGrn.desc}>{item.value}</p>
                          </Row>
                          <Row>
                            <p style={data.purchaseGrn.prodTitle}>{item.name}</p>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={6} style={{ alignSelf: "center" }}>
                      <div style={data.purchaseGrn.qtyInputsDiv}>
                        <MinusOutlined style={data.purchaseGrn.decrementInpt} type="minus" onClick={() => onFieldButton(index, "minus")} />
                        <Form.Item style={data.purchaseGrn.qtyInputFormitem}>
                          <Input
                            type="number"
                            min="0"
                            value={item.qty}
                            style={data.purchaseGrn.qtyInput}
                            onChange={(e) => {
                              onFieldButton(index, e.target.value);
                            }}
                          />
                        </Form.Item>
                        <PlusOutlined style={data.purchaseGrn.incrementInpt} type="plus" onClick={() => onFieldButton(index, "plus")} />
                      </div>
                    </Col>
                    <Col span={6} />
                  </Row>
                ))}
              </Scrollbars>
            </div>
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ margin: "10% 0px" }} />
          )}
          <div style={{ display: wastageTypeProductList.length > 0 ? "block" : "none" }}>
            <Row style={{ padding: 10 }}>
              <Col span={12}>
                <p style={data.purchaseGrn.totalProducts}>Total Products: {_.filter(wastageTypeProductList, item => item.qty > 0)?.length || 0}</p>
              </Col>
              <Col span={6}>
                <p style={data.purchaseGrn.totalWastageQty}>Total WastageQty: {_.sumBy(wastageTypeProductList, "qty")} </p>
              </Col>
              <Col span={6} />
            </Row>
            <Row style={{ padding: 10 }}>
              <Col span={21} />
              <Col span={3} style={{ float: "right" }}>
                <Button style={data.purchaseGrn.receiveBtn} onClick={handleReceive}>
                  <span style={data.purchaseGrn.receiveBtn.label}>CONFIRM</span>
                </Button>
              </Col>
            </Row>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default STReceipt;
